export enum Roles {
    user = "user",
    admin = "admin",
    adminlight = "adminlight",
    carrier = "carrier",
    superuser = "superuser",
    recipient = "recipient",
	it = "it"
}
